import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Card, CardHeader, CardContent, Icon, Typography, Divider} from '@material-ui/core'
import {compose} from 'redux'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { CtxCotation, withCotation } from 'src/page/Consumer/Cotation/CotationProvider'
import { withRouter, RouteComponentProps } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/type/lib/withToast'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { formatDate } from 'src/core/i18n/date'
import ScrollableFeed from 'react-scrollable-feed'
import { getComment, addComment } from 'src/core/redux/action/cotationAction'
import { getUserBestName } from 'src/shared/utils/helpers'
import Btn from 'src/shared/Btn/Btn'
import { ActionsBar } from 'src/shared/ActionsBar/ActionsBar'
import ReactHtmlParser from 'react-html-parser'
import MessageText from 'src/shared/MessageText/MessageText'
import { fade } from '@material-ui/core/styles/colorManipulator'

const styles = (t: Theme) => createStyles({
    card: {
      height: '100%',
      marginBottom: t.spacing.unit * 2
    },
    cardTitle: {fontSize: '1.2rem',textTransform: 'uppercase'},
    comments: {
      marginBottom: t.spacing.unit * 2,
      maxHeight: '400px',
      overflow: 'hidden',
      overflowY: 'auto'
    },
    commentWpr: {
      textAlign: 'justify'
    },
    comment: {
      display: 'flex',
      flexDirection: 'column',
      width: '90%',
      padding: '0.5rem 1rem',
      fontWeight: 400
    },
    commentLeft: {
      background: `${fade("#039BE5", .5)}`,
      borderRadius: '25px 25px 25px 0'
    },
    commentRight: {
      background: `${fade("#ed494e", .5)}`,
      borderRadius: '25px 25px 0 25px'
    },
    sender: {
      padding: '5px 10px'
    }
});

interface IProps extends WithI18n,
  WithToast,
  WithGlobalProgress,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  CtxCotation {
}

interface IState {
  newComment: string;
}

const MessageContent = (message: any) => (ReactHtmlParser(message))

class Comment extends React.Component<IProps, IState> {

  state = {
    newComment: ""
  }

  render() {
    const {t, classes, comments} = this.props;
    const {newComment} = this.state;
    
    return (
      <Card className={classes.card}>
          <CardHeader classes={{title: classes.cardTitle}}  title={
            <div style={{display: 'flex', alignItems: 'center'}}>
              <Icon style={{marginRight: '5px'}}>forum</Icon>
              Commentaires
            </div>
          }/>
          <CardContent style={{overflow: 'visible'}}>
            {comments &&
              <>
                <div className={classes.comments}>
                <ScrollableFeed>
                  {comments.map((m, i) => (
                      <>
                        <div className={classes.commentWpr}>
                          <Typography 
                            variant="body2" 
                            className={`${classes.comment} ${m.tag !== 'arkea' ? classes.commentLeft : classes.commentRight} message-text`}
                            style={{
                              marginLeft: m.tag !== 'arkea' ? '0' : 'auto',
                              marginRight: m.tag !== 'arkea'? 'auto' : '0'
                            }}
                          >
                            {MessageContent(m.message)}
                          </Typography>
                          <Typography 
                            variant="caption" 
                            className={classes.sender}
                            style={{
                              textAlign: m.tag !== 'arkea' ? 'left' : 'right'
                            }}
                          >
                            {getUserBestName(m.author)} - {formatDate(m.publish_at)}
                          </Typography>
                        </div>
                      </>
                  ))}
                </ScrollableFeed>
                </div>
                <Divider style={{margin: '1rem 0'}} />
                <div>
                  <MessageText onChange={this.handleChange} value={newComment}/>
                  <ActionsBar>
                    <Btn
                        color="primary"
                        variant="raised"
                        onClick={this.submitComment}
                        disabled={!(newComment.length > 0)}
                    >
                        {t.send}
                    </Btn>
                  </ActionsBar>
                </div>
              </>
            }
          </CardContent>
      </Card>
    )
  }

  componentDidMount(){
    const {match} = this.props
    this.props.fetch({
      order_by: "asc",
      sort_by: "publish_at",
      target_id : match.params.cotationId,
      target_type: "COTATION"
    })
  }

  @autobind
  private handleChange(value){
    this.setState({newComment: value});
  };

  @autobind
  private submitComment(){
    const { promisesWithProgress, toastError, toastSuccess, match, t} = this.props

    if(this.state.newComment && this.state.newComment.length > 0){
      promisesWithProgress(
          this.props.addComment({message: this.state.newComment},  match.params.productType, match.params.cotationId).then(res => {
          toastSuccess(t.action_success)
          this.refeshAfterChange()
        }).catch(err => toastError(err.msg))
      )
    }
  }

  @autobind
  private refeshAfterChange(){
    this.setState({newComment: ""})
    this.props.fetch({
      order_by: "asc",
      sort_by: "publish_at",
      target_id : this.props.match.params.cotationId,
      target_type: "COTATION"
    })
  }

}

const state2props = (state: RootState) => ({
  connectedUser: state.accountInfo.connectedUser,
  comments: state.paginate.cotationComment.entities
})


const dispatch2props = (dispatch: any) => ({
  fetch: (criteria: any) => dispatch(getComment(criteria)),
  addComment: (msg: any, productType: string, id: string) => dispatch(addComment(msg, productType, id)),
})

export default compose(
  withCotation,
  withRouter,
  withI18n,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props)
)(Comment)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotation/Comment.tsx